import { ContactContextLocation } from "shared/enums/ContactContextLocation";
import Icon from ".";

export namespace ComposedIcons {
  export function ContextLocationType(props: { type: ContactContextLocation }) {
    switch (props.type) {
      case ContactContextLocation.AGENDA:
        return <Icon.AgendaConfig className="contextType_agenda" />;
      case ContactContextLocation.BOOTH:
        return <Icon.StoreLight className="contextType_booth" />;
      case ContactContextLocation.OTHER:
        return <Icon.Custom className="contextType_other" />;

      default:
        return null;
    }
  }

  export function TicketBorder() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="274" height="12" viewBox="0 0 274 12">
        <path d="M8.88019 1.11951C9.63764 0.447141 10.7782 0.447143 11.5356 1.11951L19.4655 8.15866C20.8413 9.37996 19.9775 11.6544 18.1378 11.6544H2.27801C0.438303 11.6544 -0.425548 9.37995 0.950295 8.15866L8.88019 1.11951Z" />
        <path d="M28.3543 1.11951C29.1118 0.447141 30.2523 0.447143 31.0097 1.11951L38.9396 8.15866C40.3155 9.37996 39.4516 11.6544 37.6119 11.6544H21.7521C19.9124 11.6544 19.0486 9.37995 20.4244 8.15866L28.3543 1.11951Z" />
        <path d="M47.8284 1.11951C48.5859 0.447141 49.7264 0.447143 50.4839 1.11951L58.4137 8.15866C59.7896 9.37996 58.9257 11.6544 57.086 11.6544H41.2262C39.3865 11.6544 38.5227 9.37995 39.8985 8.15866L47.8284 1.11951Z" />
        <path d="M67.3026 1.11951C68.06 0.447141 69.2005 0.447143 69.958 1.11951L77.8879 8.15866C79.2637 9.37996 78.3999 11.6544 76.5602 11.6544H60.7004C58.8607 11.6544 57.9968 9.37995 59.3727 8.15866L67.3026 1.11951Z" />
        <path d="M86.7767 1.11951C87.5341 0.447141 88.6746 0.447143 89.4321 1.11951L97.362 8.15866C98.7378 9.37996 97.874 11.6544 96.0343 11.6544H80.1745C78.3348 11.6544 77.4709 9.37995 78.8468 8.15866L86.7767 1.11951Z" />
        <path d="M106.251 1.11951C107.008 0.447141 108.149 0.447143 108.906 1.11951L116.836 8.15866C118.212 9.37996 117.348 11.6544 115.508 11.6544H99.6486C97.8089 11.6544 96.9451 9.37995 98.3209 8.15866L106.251 1.11951Z" />
        <path d="M125.725 1.11951C126.482 0.447141 127.623 0.447143 128.38 1.11951L136.31 8.15866C137.686 9.37996 136.822 11.6544 134.983 11.6544H119.123C117.283 11.6544 116.419 9.37995 117.795 8.15866L125.725 1.11951Z" />
        <path d="M145.199 1.11951C145.956 0.447141 147.097 0.447143 147.854 1.11951L155.784 8.15866C157.16 9.37996 156.296 11.6544 154.457 11.6544H138.597C136.757 11.6544 135.893 9.37995 137.269 8.15866L145.199 1.11951Z" />
        <path d="M164.673 1.11951C165.431 0.447141 166.571 0.447143 167.329 1.11951L175.258 8.15866C176.634 9.37996 175.77 11.6544 173.931 11.6544H158.071C156.231 11.6544 155.367 9.37995 156.743 8.15866L164.673 1.11951Z" />
        <path d="M184.147 1.11951C184.905 0.447141 186.045 0.447143 186.803 1.11951L194.733 8.15866C196.108 9.37996 195.245 11.6544 193.405 11.6544H177.545C175.705 11.6544 174.842 9.37995 176.217 8.15866L184.147 1.11951Z" />
        <path d="M203.621 1.11951C204.379 0.447141 205.519 0.447143 206.277 1.11951L214.207 8.15866C215.583 9.37996 214.719 11.6544 212.879 11.6544H197.019C195.18 11.6544 194.316 9.37995 195.692 8.15866L203.621 1.11951Z" />
        <path d="M223.096 1.11951C223.853 0.447141 224.993 0.447143 225.751 1.11951L233.681 8.15866C235.057 9.37996 234.193 11.6544 232.353 11.6544H216.493C214.654 11.6544 213.79 9.37995 215.166 8.15866L223.096 1.11951Z" />
        <path d="M242.57 1.11951C243.327 0.447141 244.468 0.447143 245.225 1.11951L253.155 8.15866C254.531 9.37996 253.667 11.6544 251.827 11.6544H235.967C234.128 11.6544 233.264 9.37995 234.64 8.15866L242.57 1.11951Z" />
        <path d="M262.044 1.11951C262.801 0.447141 263.942 0.447143 264.699 1.11951L272.629 8.15866C274.005 9.37996 273.141 11.6544 271.301 11.6544H255.442C253.602 11.6544 252.738 9.37995 254.114 8.15866L262.044 1.11951Z" />
      </svg>
    );
  }

  export function AIIcon() {
    return (
      <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.2731 8.55325C9.77976 8.10398 7.04446 4.94782 6.86006 1.05035H6.4093C6.2249 4.94782 3.49985 8.10398 -0.00378418 8.55325V8.66557C3.45887 9.10361 6.16343 12.2036 6.39906 16.0449H6.86006C7.09569 12.1924 9.81049 9.09238 13.2731 8.66557V8.55325Z"
          fill="var(--aiColor)"
          transform-origin="center">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;0.6;1"
            dur="2s"
            repeatCount="indefinite"
            additive="sum"
          />
        </path>
        <path
          d="M14.5845 13.2145C13.2527 13.046 12.2077 11.8442 12.136 10.3504H11.9618C11.8901 11.833 10.8554 13.0348 9.5134 13.2145V13.2594C10.8349 13.4279 11.8594 14.6072 11.9516 16.0674H12.1258C12.218 14.596 13.2527 13.4167 14.564 13.2594V13.2145H14.5845Z"
          fill="var(--aiColor)"
          transform-origin="center">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;1.2;1"
            dur="1.5s"
            repeatCount="indefinite"
            begin="0.3s"
            additive="sum"
          />
        </path>
        <path
          d="M14.5845 3.43151C13.2527 3.26304 12.2077 2.06122 12.136 0.567383H11.9618C11.8901 2.04999 10.8554 3.2518 9.5134 3.43151V3.47644C10.8349 3.64492 11.8594 4.82427 11.9516 6.28441H12.1258C12.218 4.81304 13.2527 3.63369 14.564 3.47644V3.43151H14.5845Z"
          fill="var(--aiColor)"
          transform-origin="center">
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;1.1;1"
            dur="1.5s"
            repeatCount="indefinite"
            begin="0.6s"
            additive="sum"
          />
        </path>
      </svg>
    );
  }
  export function AILoader() {
    return (
      <svg width="500" height="200" viewBox="0 0 500 200" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(50, 10) scale(0.8)">
          <use href="#star1" additive="sum" />
        </g>
        <g transform="translate(175, 10) scale(0.8)">
          <use href="#star2" />
        </g>
        <g transform="translate(325, 10) scale(0.8)">
          <use href="#star3" />
        </g>
        <g transform="translate(475, 10) scale(0.8)">
          <use href="#star4" />
        </g>

        <g transform="translate(100, 60) scale(1)">
          <use href="#star5" />
        </g>
        <g transform="translate(250, 60) scale(1)">
          <use href="#star6" />
        </g>
        <g transform="translate(400, 60) scale(1)">
          <use href="#star7" />
        </g>

        <g transform="translate(50, 120) scale(0.8)">
          <use href="#star8" />
        </g>
        <g transform="translate(175, 120) scale(0.8)">
          <use href="#star9" />
        </g>
        <g transform="translate(325, 120) scale(0.8)">
          <use href="#star10" />
        </g>
        <g transform="translate(475, 120) scale(0.8)">
          <use href="#star11" />
        </g>

        <g transform="translate(100, 170) scale(1)">
          <use href="#star12" />
        </g>
        <g transform="translate(250, 170) scale(1)">
          <use href="#star13" />
        </g>
        <g transform="translate(400, 170) scale(1)">
          <use href="#star14" />
        </g>

        <defs>
          <g id="star1" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.5s"
              begin="0s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star2" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.6s"
              begin="0.2s"
              repeatCount="indefinite"
              additive="sum"
            />
          </g>
          <g id="star3" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.4s"
              begin="0.4s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star4" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1.4;0"
              dur="1.7s"
              begin="0.6s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star5" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1.4;0"
              dur="1.8s"
              begin="0.3s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star6" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1.4;0"
              dur="1.5s"
              begin="0.5s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star7" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.9s"
              begin="0.7s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star8" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.3s"
              begin="0.9s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star9" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.6s"
              begin="1.1s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star10" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.5s"
              begin="1.3s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star11" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.7s"
              begin="1.5s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star12" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.8s"
              begin="1.7s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star13" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="1.9s"
              begin="1.9s"
              repeatCount="indefinite"
            />
          </g>
          <g id="star14" opacity="0">
            <use href="#baseStar" />
            <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="0s" fill="freeze" />
            <animateTransform
              attributeName="transform"
              type="scale"
              values="0;1;0"
              dur="2.0s"
              begin="2.1s"
              repeatCount="indefinite"
            />
          </g>

          <g id="baseStar" transform="translate(6.5, 8.5)">
            <path
              d="M13.2731 8.55325C9.77976 8.10398 7.04446 4.94782 6.86006 1.05035H6.4093C6.2249 4.94782 3.49985 8.10398 -0.00378418 8.55325V8.66557C3.45887 9.10361 6.16343 12.2036 6.39906 16.0449H6.86006C7.09569 12.1924 9.81049 9.09238 13.2731 8.66557V8.55325Z"
              fill="#7A1CAC"
            />
          </g>
        </defs>
      </svg>
    );
  }
}
